<template>
  <ym-iframe-page class="page page-may-course-2020"
                  :page-url="render.pageUrl"
                  :contact-info="contactInfo"
                  v-if="contactInfo"
  />
</template>

<script>
  import YmIframePage from '@/components/YmIframePage';
  import getMayCourseInfo from '@/services/may-course-2020';

  export default {
    name: 'MayCourse2020',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      YmIframePage,
    },
    data() {
      return {
        render: {
          pageTitle: '',
          pageUrl: '',
        },
        contactInfo: null,
      };
    },
    methods: {
      async fetchData() {
        const data = await getMayCourseInfo();
        this.render = data.render;
        this.contactInfo = data.contactInfo;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-may-course-2020 {
    height: 100%;
    color: #fff;
  }

</style>

